import styles from './battery.module.css';
import DOMPurify from 'dompurify';
const Battery = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <div className={styles.textBox}>
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M50.6666 13.332H7.99992C7.29267 13.332 6.6144 13.613 6.1143 14.1131C5.6142 14.6132 5.33325 15.2915 5.33325 15.9987V47.9987C5.33325 48.7059 5.6142 49.3842 6.1143 49.8843C6.6144 50.3844 7.29267 50.6654 7.99992 50.6654H50.6666C51.3738 50.6654 52.0521 50.3844 52.5522 49.8843C53.0523 49.3842 53.3332 48.7059 53.3332 47.9987V15.9987C53.3332 15.2915 53.0523 14.6132 52.5522 14.1131C52.0521 13.613 51.3738 13.332 50.6666 13.332ZM38.6666 29.5745H30.4999V18.6654L19.9999 34.4229H28.1666V45.332L38.6666 29.5745Z"
            fill="#3DCCCC"
          />
          <path
            opacity="0.4"
            d="M61.3333 24H56V40H61.3333V24Z"
            fill="#3DCCCC"
          />
        </svg>

        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text29']),
          }}
        ></h1>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text30']),
          }}
        ></h5>
      </div>

      <div className={styles.paramsBox}>
        <div className={styles.paramsItem}>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text31']),
            }}
          ></div>
          <h2
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text32']),
            }}
          ></h2>
        </div>

        <div className={styles.line}></div>

        <div className={styles.paramsItem}>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text33']),
            }}
          ></div>
          <h2
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text34']),
            }}
          ></h2>
        </div>
      </div>

      <img src="http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-battery.jpg" alt="" />
    </div>
  );
};

export default Battery;
